import React from "react";
import { useAuth } from "./AuthContext";
import "./Login.css";

export default function Login() {
  const { signInWithGoogle, authError, isSigningIn } = useAuth();

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1 className="login-title">DIPA Panchang</h1>
        <p className="login-subtitle">Sign in with Google to continue</p>
        <button
          type="button"
          className="login-google-btn"
          onClick={signInWithGoogle}
          disabled={!!authError || isSigningIn}
        >
          <span className="login-google-icon">G</span>
          {isSigningIn ? "Signing in…" : "Sign in with Google"}
        </button>
        {authError && (
          <p className="login-error" role="alert">
            {authError}
          </p>
        )}
      </div>
    </div>
  );
}
